import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth.js";
import { useParams } from "react-router-dom";
import { getUserById } from "../models/UserFunctions.js"; // Function to fetch user data
import { transformMastersToTable } from "../models/OrgFunctions.js"; // Functions to fetch org and client data
import Column from "../layout/Column.js";
import Row from "../layout/Row.js";
import Divider from "../layout/Divider.js";
import Space from "../layout/Space.js";
import DataGridFull from "../tables/DataGridFull.js";
import { useTheme } from "@mui/material";
import PrimaryButton from "../buttons/PrimaryButton.js";
import Icon1 from "../icons/Icon.js";
import { Skeleton } from "@mui/material";
import TFGPT1 from "../textfields/TFGPT1.js";
import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
  queryCollection,
} from "../models/DataFunctions.js";
import checkPageAccess from "../auth/checkPageAccess.js";
import ClientTabs from "../tabs/ClientTabs.js";
import { useSnackbar } from "notistack";
import DataGridGPT2 from "../tables/DataGridGPT2.js";

function Masters({ userData, orgData, navigateWorkspace, workspaceData }) {
  const theme = useTheme();
  const { currentUser, loading } = useAuth();

  const [searchValue, setSearchValue] = useState("");
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [workspaces, setWorkspaces] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const [allMasters, setAllMasters] = useState([]);

  const tabContent = [<span></span>, <span></span>, <span></span>];

  const [tabindex, setTabIndex] = useState(0);
  // Function to fetch user data by ID

  // Function to navigateWorkspace to a client by ID

  const handleSwitchWorkspace = async (workspace_id) => {
    // check if already in a workspace

    navigateWorkspace("/home", orgData, workspace_id);
  };

  // Function to fetch data for the current user
  const handleFetchData = async () => {
    if (userData) {
      try {
        // Fetch user data by currentUser's ID

        const workspaces = await getArrayDocDataByID(
          "workspace",
          orgData.workspaces_id || []
        );
        setWorkspaces(workspaces);

        // Parallel fetching of organization and clients
        const masters = await getArrayDocDataByID("org", orgData.masters_id);

        // Transform clients into table format (rows and columns)
        const { rows, columns } = transformMastersToTable(
          masters,
          workspaceData,
          handleSwitchWorkspace,
          workspaces
        );

        // Update state if the user data is new or changed
        // Batch state updates to minimize re-renders

        setAllMasters(masters);
        setRows(rows);
        setColumns(columns);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  // Fetch data when the component mounts or when currentUser changes
  useEffect(() => {
    if (currentUser) {
      handleFetchData();
    }
  }, [currentUser]);

  // If the data is still loading or the user is not authenticated, show a loading message
  if (loading || !currentUser || !userData) {
    return (
      <div className="h-full w-full pl-4 flex flex-col gap-2">
        <div className="w-full h-full flex flex-row gap-2">
          <div className="h-full w-full overflow-hidden max-w-c1p4k flex flex-col gap-2">
            {/* Skeleton for the title */}
            <Skeleton variant="text" width={80} height={40} />
            <div className="w-full justify-between flex flex-row align-bottom">
              {/* Skeleton for Search Bar */}
              <Skeleton variant="rounded" width={400} height={30} />

              {/* Skeleton for New Folder Button */}
              <Skeleton variant="rounded" width={150} height={30} />
            </div>

            {/* Skeleton for DataGrid */}
            <Skeleton variant="rounded" width="100%" height={400} />
          </div>
          <Divider orientation="vertical" />
        </div>
      </div>
    );
  }

  // Render the client data
  return (
    <div align="left" className="h-full w-full pl-4">
      <div className="text-h1 font-bold text-left">Espaces de travail</div>
      <div className="text-h3 text-left text-shadow_50 mt-2 max-w-c400">
        Si vous êtes invités à travailler sur les dossiers de quelqu'un d'autre,
        vous aurez accès à leurs espaces de travail ici.
      </div>

      {/* DataGrid displaying the clients */}
      <div className="w-full h-5/6 max-w-c1p2k mt-6 pb-14 min-h-6">
        <DataGridGPT2
          rows={rows}
          columns={columns}
          onClick={() => {}}
          selectable={false}
          initial_sort_field={"date"}
        />
      </div>
    </div>
  );
}

export default Masters;
